import React from 'react'

export default function HighlightsText({ className='', color, ...etc }) {
    return (
        <div 
            {...etc}
            className={'ui-highlight-text' + ' ' + className}
            style={{'--highlight-color': color}} />
    )
}